export { MODE_FULLTEXT_SEARCH, MODE_HYBRID_SEARCH, MODE_VECTOR_SEARCH } from './constants.js';
export const kInsertions = Symbol('orama.insertions');
export const kRemovals = Symbol('orama.removals');

//# sourceMappingURL=types.js.map